module.exports = __webpack_public_path__ + "static/media/terapia-bajka_large.3ab587fc.jpg";